import { Component, Input, OnDestroy, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { PusherService } from "../../services/pusher.service";

@Component({
    selector: "page-user-activities",
    templateUrl: "page-user-activities.component.html",
    styleUrls: ["page-user-activities.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageUserActivitiesComponent implements OnInit, OnDestroy {
    @Input() text: string = "Viewing";
    @Input() channel: string;
    
    onlineUsers: any[] = [];
    onlineCount: number = 0;
    private channelName: string = "";

    constructor(
        private pusherService: PusherService,
        private cdr: ChangeDetectorRef
    ) {}

    public ngOnInit(): void {
        if (this.channel) {
            this.channelName = this.channel;            
            this.pusherService.echo.join(this.channelName)
                .here((users: any[]) => {
                    this.onlineUsers = users;
                    this.onlineCount = users.length;
                    this.cdr.markForCheck();
                })
                .joining((user: any) => {
                    this.onlineUsers.push(user);
                    this.onlineCount = this.onlineUsers.length;
                    this.cdr.markForCheck();
                })
                .leaving((user: any) => {
                    this.onlineUsers = this.onlineUsers.filter(u => u.id !== user.id);
                    this.onlineCount = this.onlineUsers.length;
                    this.cdr.markForCheck();
                })
                .error((error: any) => {
                    console.error("❌ Channel error:", error);
                });
        } else {
            console.warn("⚠️ No channel provided to PageUserActivitiesComponent");
        }
    }

    public ngOnDestroy(): void {
        if (this.channelName) {
            this.pusherService.echo.leave(this.channelName);
        }
    }

    public getUserHint(): string {
        if (this.onlineUsers.length === 0) {
            return "No users currently viewing";
        }
        
        const userNames = this.onlineUsers.map(user => {
            const name = user.name || user.nickname || "User " + user.id;
            const email = user.email || "";
            return email ? `${name} (${email})` : name;
        });
        
        return userNames.join(", ");
    }
}
